import { atom } from "recoil"

export const activityTypesAtom = atom({
    key: "activityTypesAtom",
    default: []
})
